<template>


    <draggable v-model="assets" element="div" @end="dragEnd" :options="{ handle: '.dragHandler', animation: 250 }" class="columns assetsContainer" v-if="assets && assets.length > 0">

        <div v-for="(asset, index) in assets" :key="asset.id" class="col asset" v-if="checkCondition(asset) === true">

            <div class="dragHandler" title="verschieben" v-if="enableDragDrop">
                <span class="icon is-small">
                    <i class="fa icon-ak-move" aria-hidden="true"></i>
                </span>
            </div>

            <div class="imgContainer">

                <img class="lazy-img-fadein" :src="getAsset(asset.asset)" />

                <pop-confirm v-if="!isReadOnly" :content="$t('CONFIRMATION-DELETE_ASSET')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeAsset(index, asset.asset) }">
                    <button :class="[{'is-disabled': isReadOnly}, 'button is-single is-small is-danger']" title="löschen">
                        <span class="icon is-small">
                            <i class="fa fa-trash-o"></i>
                        </span>
                    </button>
                </pop-confirm>

            </div>

            <div class="productAssetTypeSelector" v-if="product != null">
                <span class="select is-small">
                    <select v-model="product.productAssets[index].type" :class="{'is-disabled': isReadOnly}">
                        <option v-for="assetType in productAssetTypes" :value="assetType.id">{{ $t('SELECT_BOX-PRODUCT-PRODUCT_ASSET_TYPE-' + assetType.name) }}</option>
                    </select>
                </span>
            </div>

            <tooltip :content='`Download "` + getAssetDownloadFilename(asset.asset) +`"`'>
                <a :href="getAssetDownloadLink(asset.asset)" :download="getAssetDownloadFilename(asset.asset)" class="downloadLink" title="download">
                    <span class="icon is-small">
                        <i class="fa icon-ak-download"></i>
                    </span>
                </a>
            </tooltip>

        </div>

    </draggable>


    <!--
    <div class="columns assetsContainer" v-if="assets != null && assets.length > 0">

        <div class="col asset" v-for="(asset, index) in assets" :key="asset.id" v-if="checkCondition(asset) === true">

            <div class="imgContainer">

                <img class="lazy-img-fadein" :src="getAsset(asset.asset)" />

                <pop-confirm v-if="!isReadOnly" :content="$t('CONFIRMATION-DELETE_ASSET')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeAsset(index) }">
                    <button :class="[{'is-disabled': isReadOnly}, 'button is-single is-small is-danger']" title="löschen">
                        <span class="icon is-small">
                            <i class="fa fa-trash-o"></i>
                        </span>
                    </button>
                </pop-confirm>

            </div>

            <div class="productAssetTypeSelector" v-if="product != null">
                <span class="select is-small">
                    <select v-model="product.productAssets[index].type" :class="{'is-disabled': isReadOnly}">
                        <option v-for="assetType in productAssetTypes" :value="assetType.id">{{ $t('SELECT_BOX-PRODUCT-PRODUCT_ASSET_TYPE-' + assetType.name) }}</option>
                    </select>
                </span>
            </div>

            <tooltip :content='`Download "` + getAssetDownloadFilename(asset.asset) +`"`'>
                <a :href="getAssetDownloadLink(asset.asset)" :download="getAssetDownloadFilename(asset.asset)" class="downloadLink" title="download">
                    <span class="icon is-small">
                        <i class="fa icon-ak-download"></i>
                    </span>
                </a>
            </tooltip>

        </div>

    </div>
    -->


</template>


<script>
import draggable from 'vuedraggable';

export default {

    components: {
        draggable
    },

    props: {

        assets: {
            type: Array,
            default: null
        },
        specialCondition: {
            type: Boolean,
            default: false
        },
        conditionId: {
            type: Number,
            default: null
        },
        product: {
            type: Object,
            default: null
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        enableDragDrop: {
            type: Boolean,
            default: false
        },
        thumbDir: {
            type: String,
            default: ''
        }

    },

    computed: {

        productAssetTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
		}

    },

    mounted() {

    },

    methods: {

        checkCondition(asset) {

            if(asset.asset == null) {
                return false;
            }

            if(this.specialCondition == true) {
                return asset.category == this.conditionId;
            }

            return true;

        },

        getAsset(asset) {

            if(typeof asset.filename == "undefined") {
                return false;
            }

            let url = asset.filename;

            // get file extension
            let ext = (url.split('.').pop()).toLowerCase();

            // check if we've an image
            if(ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'png') {

                return this.$config.assets + asset.path + '/' + (this.thumbDir != "" ? this.thumbDir + '/' : '') + asset.filename;

            }

            // otherwise we display a predefined icon
            let extensions = ['ai', 'eps', 'indd', 'pdf', 'psd', 'tiff', 'tif', 'doc', 'docx', 'xls', 'xlsx'];

            if(extensions.indexOf(ext) > -1) {
                return require('../../assets/img/fileTypes/datei-'+ext+'.png');
            } else {
                return require('../../assets/img/fileTypes/datei-undefined.png');
            }


        },

        getAssetDownloadLink(asset) {

            return this.$config.assets + asset.path + '/' + asset.filename;

        },

        getAssetDownloadFilename(asset) {

            return asset.uploadFilename != null ? asset.uploadFilename : asset.filename;

        },

        removeAsset(index, asset) {

            // console.log("asset: ", asset);
            this.$emit('removeAsset', { index: index, asset: asset });

        },

        dragEnd() {

            this.resortAssets();
            // this.$emit('update', this.assets);

        },

        resortAssets() {
            for(var i=0; i < this.assets.length; i++) {
                this.assets[i].sortorder = i;
            }
        }

    }

}
</script>


<style scoped>

    .assetsContainer {
        border: none !important;
        margin: 0 0 25px 0 !important;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
    }
    .assetsContainer::after {
        content: "";
        /*flex: 1 1 100%;*/
        width: 100%;
        min-width: 100px;
        max-width: 32.5%;
        margin-bottom: 10px;
    }
    .assetsContainer .asset {
        position: relative;
        background: #f5f5f5;
        padding: 0;
        margin: 0 0 10px 0;
        border: 1px solid #e9e9e9;
        border-radius: 2px;
        transition: border-color .3s ease;

        display: flex;
        align-items: center;
        flex-direction: column;

        width: 100%;
        min-width: 100px;
        max-width: 32.5%;
        margin-bottom: 10px;
    }
    .assetsContainer .asset .imgContainer {
        height: 100px;
        background: #fff;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .assetsContainer .asset .imgContainer img {
        max-height: 100%;
    }
    .assetsContainer .imgContainer .button {
    	position: absolute;
    	z-index: 99;
    	right: 0;
    	top: 0;
    	opacity: 0;
    	transition: all .3s ease;
        border-radius: 0 !important;
        border-bottom-left-radius: 2px !important;
    }
    .assetsContainer .imgContainer:hover .button {
    	opacity: 1;
    }
    .assetsContainer .imgContainer .button .icon {
    	margin: 0 auto !important;
        width: 14px;
        height: 14px;
        line-height: 14px;
    }
    .assetsContainer .imgContainer .button i {
    	font-size: 10px;
    }
    .assetsContainer .downloadLink {
        display: block;
        text-align: center;
        transition: background .5s ease;
        height: auto !important;
        padding: 0 !important;
        border: none;
    }
    .assetsContainer .downloadLink:hover {
        background-color: #eee;
        border: none;
    }
    .assetsContainer .downloadLink:hover .icon i {
        color: #222;
    }
    .assetsContainer .downloadLink .icon {
        display: inline-block;
        margin: 5px auto !important;
        vertical-align: middle;
        height: auto;
    }
    .assetsContainer .downloadLink .icon i {
        color: #aaa;
        transition: color .5s ease;
    }

    .productAssetTypeSelector {
        margin: 5px auto;
        text-align: center;
    }
    .productAssetTypeSelector .select {
        margin: 0 auto;
        max-width: 120px;
    }
    .productAssetTypeSelector select option {
        padding: 10px !important;
        margin: 10px !important;
    }

    /* drag handler */
    .asset .dragHandler {
        position: absolute;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background: #f1f1f1;
        cursor: grabbing;
        vertical-align: middle;
        text-align: center;
        transition: all .2s ease;
        border-bottom-right-radius: 2px;
        opacity: 0;
    	transition: all .3s ease;
    }
    .asset:hover .dragHandler {
        opacity: 1;
    }
    .asset .dragHandler .icon {
        vertical-align: middle;
        color: #bbb;
        transition: color .2s ease;
    }
    .asset .dragHandler:hover {
        background-color: #ddd;
    }
    .asset .dragHandler:hover .icon {
        color: #000;
    }

</style>
